import useCurrentPlatformId from './useCurrentPlatformId';

export function useWorkflowRunsListHref() {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/workflow-runs`;
}

export function useWorkflowRunShowHref({ id }: { id: string }) {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/workflow-runs/${id}`;
}

export function useWorkflowsListHref() {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/workflows`;
}

export function useEmailMessageShowHref({ id }: { id: string }) {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/events/${id}`;
}

export function useRequestLogsListHref() {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/request-logs`;
}

export function useTemplatesListHref(props: { type?: 'LAYOUT' } = {}) {
  const { type } = props;
  const platformId = useCurrentPlatformId();
  if (type === 'LAYOUT') {
    return `/o/${platformId}/templates?type=LAYOUT`;
  }
  return `/o/${platformId}/templates`;
}

export function useWorkflowShowHref({ id }: { id: string }) {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/workflows/${id}`;
}

export function useApiKeyNewHref() {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/settings/api-keys/new`;
}

export function useContactsListHref() {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/contacts`;
}

export function useContactShowHref({ id }: { id: string }) {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/contacts/${id}`;
}

export function useGroupsListHref() {
  const platformId = useCurrentPlatformId();
  return `/o/${platformId}/groups`;
}
